<template>
    <div class="jump-cart">
        <van-nav-bar title="订单列表" left-arrow fixed class="jump-nav-bar" @click-left="back">
        </van-nav-bar>
        <div class="jump-cart-body">
            <div class="jump-cart-body-hd"></div>
            <van-tabs v-model="tabActive" @click="getOrderData" style="margin-bottom: 20px;">
                <van-tab title="全部"></van-tab>
                <van-tab title="待付款"></van-tab>
                <van-tab title="待发货"></van-tab>
                <van-tab title="已发货"></van-tab>
                <van-tab title="已收货"></van-tab>
                <van-tab title="已完成"></van-tab>
                <van-tab title="已取消"></van-tab>
            </van-tabs>

            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-row class="jump-cart-item" v-for="item in list">
                    <van-row v-if="item.goodsList.length>0">
                        <van-col span="9" class="jump-cart-item-img">
                            <a :href="'#/gooddetail/'+item.goodsList[0].id"> <img :src="item.goodsList[0].picUrl"/></a>
                        </van-col>
                        <van-col span="15" class="jump-cart-item-warp">
                            <a :href="'#/gooddetail/'+item.goodsList[0].id">
                                <p class="item-time">{{item.createtime | formatTime('yyyy-MM-dd')}} <span
                                        class="order-cancel">{{item.orderStatusName}}</span>
                                </p>
                                <p>支付方式：{{item.payClassName}}</p>
                                <p>订单来源：{{item.orderTypeName}}<span v-if="item.reservedOrderFlag>0" style="color:red;margin-left:10px;">预售</span></p>
                                <p>订单编号：{{item.orderId}}</p>
                                <p v-if="item.goodsList[0].spec&&item.goodsList[0].spec!=''">规格：{{item.goodsList[0].spec}}</p>
                                <p class="item-price">合计：￥{{item.totalPrice}} </p></a>
                        </van-col>
                        <van-col span="24" class="jump-cart-item-foot"
                                 v-if="!item.isBmReplaceOrder && userRole.indexOf('BM')==-1">
                            <van-button size="small" plain class="btn-cancel" @click="cancelOrder(item)"
                                        v-if="(item.orderStatus == 10 && item.payClass != 3&&item.storeResult.isReject==0) || (item.orderStatus == 10 && item.payClass == 3 && item.currentSeq == 1&&item.isPartOut!=1&&item.storeResult.isReject==0) ">
                                取消订单
                            </van-button>
                            <van-button size="small" plain class="btn-cancel" @click="tuihuoOrder(item)"
                                        v-if="item.orderStatus==40 && item.workflowStatus!=0">申请退货
                            </van-button>

                            <van-button size="small" plain class="btn-cancel" @click="payOrder(item)"
                                        v-if="item.orderStatus == 10 && item.payClass != 3">付款
                            </van-button>

                            <van-button size="small" plain class="btn-cancel" @click="yanchiOrder(item)"
                                        v-if="(item.orderStatus == 30 && item.orderGoodsType != 4 && item.delayedReceipt != 1) || (item.orderStatus == 30 && item.orderGoodsType == 4 && item.confirmAgain == 1 && item.delayedReceipt != 1)">
                                延迟收货
                            </van-button>

                            <van-button size="small" plain class="btn-cancel"
                                        @click="seeOrder(item.id,item.isBmReplaceOrder)">
                                查看订单
                            </van-button>

                            <van-button size="small" plain class="btn-cancel" @click="shouhuo(item.id)"
                                        v-if="(item.orderStatus == 30) || (item.orderStatus == 30 && item.confirmAgain == 1)">
                                确认收货
                            </van-button>

                            <van-button size="small" plain class="btn-cancel" @click="pingjia(item.id)"
                                        v-if="item.orderStatus == 40">我要评价
                            </van-button>


                            <van-button size="small" plain class="btn-cancel" @click="rebuy(item.id)">
                                再次购买
                            </van-button>

                            <van-button size="small" plain class="btn-cancel" @click="outOrder(item.id)"
                                        v-if="item.isPartOut == 1">查看出库单
                            </van-button>
                            <van-button size="small" plain class="btn-cancel" @click="seeIsTrueOrder(item.id)">
                                查看确认单
                            </van-button>

                        </van-col>
                        <van-col span="24" class="jump-cart-item-foot" v-if="item.isBmReplaceOrder">
                            <van-button size="small" plain class="btn-cancel" @click="cancelOrder(item)"
                                        v-if="(item.orderStatus == 10 && item.payClass != 3&&item.storeResult.isReject==0) || (item.orderStatus == 10 && item.payClass == 3 && item.currentSeq == 1&&item.storeResult.isReject==0)">
                                取消订单
                            </van-button>
                            <van-button size="small" plain class="btn-cancel"
                                        @click="seeOrder(item.id,item.isBmReplaceOrder)">
                                查看订单
                            </van-button>
                            <van-button size="small" plain class="btn-cancel" @click="rebuy(item.id)">
                                再次购买
                            </van-button>
                            <van-button size="small" plain class="btn-cancel" @click="seeIsTrueOrder(item.id)">
                                查看确认单
                            </van-button>
                        </van-col>
                        <van-col span="24" class="jump-cart-item-foot"
                                 v-if="!item.isBmReplaceOrder&&userRole.indexOf('BM')!=-1">
                            <van-button size="small" plain class="btn-cancel"
                                        @click="seeOrder(item.id,item.isBmReplaceOrder)">
                                查看订单
                            </van-button>
                            <van-button size="small" plain class="btn-cancel" @click="seeIsTrueOrder(item.id)">
                                查看确认单
                            </van-button>
                        </van-col>

                    </van-row>
                </van-row>
            </van-list>
        </div>
        <BackTop/>
    </div>
</template>
<script>
    import {NavBar, Row, Col, Button, tab, tabs, Tab, Tabs, List} from "vant"

    export default {
        name: "userOrder",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Button.name]: Button,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [List.name]: List
        },
        data() {
            return {
                checkedAll: false,
                tabActive: 0,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1,
                type: 0,
                userRole: localStorage.getItem("userRole") ? localStorage.getItem("userRole") : "",
            };
        },
        methods: {
            onLoad() {
                let that = this
                var orderLists = JSON.parse(localStorage.getItem("orderLists"))
                var orderPage = JSON.parse(localStorage.getItem("orderPage"))
                var isTrue = true
                if (orderLists != null) {
                    if (orderLists.length != 0) {
                        that.list = orderLists
                        that.page = orderPage
                        localStorage.setItem("orderLists", JSON.stringify([]))
                        localStorage.setItem("orderPage", JSON.stringify(1))
                        isTrue = false
                        that.loading = false
                        that.finished = false
                    }
                }
                if (isTrue) {
                    let json = {"currentPage": that.page}
                    if (that.tabActive != 0) {
                        json = {"currentPage": that.page, "orderStatus": that.type}
                    }
                    // 异步更新数据
                    that.$api.post(
                        that.jumuc.order.orderList,
                        json,
                        successRes => {
                            let orderlist = successRes.data.list
                            for (let i = 0; i < orderlist.length; i++) {
                                that.list.push(orderlist[i]);
                            }
                            that.page = successRes.data.pageNum + 1
                            that.total = successRes.data.total
                            // 加载状态结束
                            that.loading = false;

                            // 数据全部加载完成
                            if (that.list.length >= that.total) {
                                that.finished = true;
                            }
                        }
                    )
                }
            },
            getOrderData(index, title) {
                let that = this
                that.list = []
                that.page = 1
                let json = {"currentPage": that.page}
                if (index != 0) {
                    if (index == 6) {
                        index = 0
                    }
                    that.type = index * 10
                    json = {"currentPage": that.page, "orderStatus": that.type}
                } else {
                    that.type = 1
                }
                localStorage.setItem("order_type", that.type)
                that.$api.post(
                    that.jumuc.order.orderList,
                    json,
                    successRes => {
                        that.list = successRes.data.list
                        that.page = successRes.data.pageNum + 1
                        that.total = successRes.data.total
                    }
                )
            }, back() {
                this.$router.push({
                    path: '/usercent'
                })
            }, pingjia(id) {
                this.$router.push({
                    path: '/user/comment/add',
                    query: {
                        id: id
                    }
                })
            }, yanchiOrder(item) {
                this.$router.push({
                    path: '/user/order/extend',
                    query: {
                        id: item.id,
                        orderId: item.orderId
                    }
                })
            }, tuihuoOrder(item) {
                this.$router.push({
                    path: '/user/order/aftersale',
                    query: {
                        id: item.id,
                        orderId: item.orderId
                    }
                })
            }, cancelOrder(item) {
                this.$router.push({
                    path: '/user/order/cancel',
                    query: {
                        id: item.id,
                        orderId: item.orderId
                    }
                })
            }, seeOrder(orderId, status) {
                let that = this
                localStorage.setItem("order_type", that.type)
                localStorage.setItem("orderLists", JSON.stringify(that.list))
                localStorage.setItem("orderPage", JSON.stringify(that.page))
                that.$router.push({
                    path: '/user/order/detail',
                    query: {
                        id: orderId,
                        status: status
                    }
                })
            }, shouhuo(id) {
                let that = this
                that.$router.push({
                    path: '/user/order/receive',
                    query: {
                        id: id
                    }
                })
            }, seeIsTrueOrder(id) {
                let that = this
                that.$router.push({
                    path: '/user/order/arrival',
                    query: {
                        id: id
                    }
                })
            }, rebuy(id) {
                let that = this
                that.$api.post(
                    that.jumuc.order.rebuy,
                    {"orderId": id},
                    successRes => {
                        that.$toast(successRes.msg)
                        if (successRes.success) {
                            that.$router.push({
                                path: '/cart',
                                query: {
                                    id: id
                                }
                            })
                        }
                    }
                )
            }, outOrder(id) {
                let that = this
                that.$router.push({
                    path: '/order/out-order',
                    query: {
                        id: id
                    }
                })
            }, payOrder(item) {
                if (item.payClass == 1) {
                    location.href = "#/order/pay?id=" + item.id +
                        "&money=" + item.shouldPayPrice +
                        "&orders=" + item.id +
                        "&orderId=" + item.orderId;
                }
                else if (item.payClass == 3) {
                    //赊销
                } else if (item.payClass == 5) {
                    //线下
                    location.href = "#/order/payoffline?orders=" + item.id +
                        "&orderId=" + item.orderId +
                        "&orderPrice=" + item.shouldPayPrice +
                        "&id=" + item.id +
                        "&uploadCertificateUrl=" + item.uploadCertificateUrl;
                }
            }
        },
        mounted: function () {
            let that = this
            let order_type = localStorage.getItem("order_type");
            if (order_type == null || order_type == '') {
                if (that.$route.query.type != undefined) {
                    that.type = that.$route.query.type
                }
            } else {
                that.type = order_type
            }
            that.tabActive = that.type / 10
            that.tabActive = that.tabActive == 0 ? 6 : that.tabActive
            that.tabActive = that.tabActive == 10 ? 0 : that.tabActive
            localStorage.setItem("order_type", that.type);
        }, filters: {
            formatTime: function (date, fmt) {
                var date = new Date(date.replace(/-/g, "/"));
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
                }
                var o = {
                    'M+': date.getMonth() + 1,
                    'd+': date.getDate(),
                    'h+': date.getHours(),
                    'm+': date.getMinutes(),
                    's+': date.getSeconds()
                };
                for (var k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) {
                        var str = o[k] + '';
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
                    }
                }
                return fmt;
            }
        },
//    beforeRouteLeave(to, from, next) {
//       from.meta.keepAlive = false;
// 	    next();
//     }

    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    button {
        margin: 5px;
    }

    .jump-cart {

        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 100%;
                }
            }

            h4 {
                font-size: 16px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 16px;
                &.item-time {
                    font-size: 16px;
                    span {
                        float: right;
                        color: @bule-thame;
                    }
                    span.order-cancel {
                        color: green;
                    }
                }
                &.item-price {
                    font-size: 16px;
                    text-align: right;
                }
            }
            &-foot {
                padding: 10px 0;
                text-align: right;
                button {
                    margin-left: 10px;
                    padding: 0 10px;
                    border-radius: 10px;
                    color: #999;
                    border-color: #999;
                }
                button.btn-cancel {
                    color: @bule-thame;
                    border-color: @bule-thame;
                }
            }
        }

    }
</style>

